import React, { useRef } from "react";
import ListCalendar from "../ListCalendar";
import _ from "underscore";
import { useAppContext } from "../../contexts/AppContext";
import ExamWrapper from "./ExamWrapper";
import { TListCalendarWrapperProps } from "../../types/components/ListCalendarWrapper";
import { TComponent } from "../../types/utils";

type TExamComponentCalendarProps = {
    id: number;
    width?: number;
    classes?: Record<string, boolean>;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [];

const ExamComponentCalendar: TComponent<TExamComponentCalendarProps> = (props) => {
    const appContext = useAppContext();
    const wrapper = useRef<HTMLElement | null>(null);

    let style: React.CSSProperties = { width: props.width, height: "100%" };

    if (props.style) {
        style = props.style;
    }
    const classes = _.extend(
        {
            reservationList: true,
        },
        props.classes
    );
    return (
        <ListCalendar
            {...props}
            className={`${props.className} prefsComponent examComponent`}
            type={"examComponent"}
            refreshEvents={getRefreshEvents()}
            privateSelected={false}
            listRef={(node) => {
                wrapper.current = node;
            }}
            fireEvent={appContext.fireEvent}
        >
            <ExamWrapper classes={classes} style={style} onInfoOpen={props.onInfoOpen} />
        </ListCalendar>
    );
};

export default ExamComponentCalendar;
